export interface IColumn {
  name: string
  label: string
  tooltip?: string
  entityId?: string
  slot?: string
  sortable?: boolean
  filterable?: FilterableTypeEnum
  type: 'string' | 'dateonly' | 'decimal'
  extraProps?: { prefix: string; [key: string]: string }
  format?:
    | ((value: string) => string)
    | ((value: number) => string)
    | ((value: boolean) => string)
    | ((value: string) => JSX.Element)
    | ((value: string) => string | undefined)
  icon?: () => JSX.Element
}

export enum FilterableTypeEnum {
  dateRange = 'dateRange',
  selectFromList = 'selectFromList',
  range = 'range',
  contains = 'contains',
  //* Left here for later usage
  // selectUsState = 'selectUsState',
}

export interface IRow {
  id: string
  onClick?: any
  [key: string]: string | number | boolean
}

export interface ISort {
  current?: string
  sortByHandler: (value: string, keepCurrentSorting?: boolean) => void
  component?: JSX.Element
}

export enum OperatorTypeEnum {
  date = 'date',
  inRange = 'inRange',
  startsWith = 'startsWith',
  endsWith = 'endsWith',
  oneOf = 'oneOf',
  contains = 'contains',
  notContains = 'notContains',
  greaterThen = 'greaterThen',
  greaterThan = 'greaterThan',
  lessThen = 'lessThen',
  lessThan = 'lessThan',
  lessThanOrEqual = 'lessThanOrEqual',
  greaterThanOrEqual = 'greaterThanOrEqual',
  range = 'range',
  // Date
  before = 'before',
  after = 'after',
  isEqual = 'isEqual',
  equals = 'equals',
  notEqual = 'notEqual',
  like = 'like',
  in = 'in',
  set = 'set',
  number = 'number',
  text = 'text',
}
export interface ITableFilter {
  current?: IApplyFilter[]
  filterByHandler: (filters: IApplyFilter) => void
  getPropUniqueValues: (prop: string) => Promise<string[]>
  component?: JSX.Element
}

export interface IPagination {
  itemsPerPage: number
  totalItems: number
  page: number
  changeItemsPerPageHandler: (itemsPerPage: number | string) => void
  changePageHandler: (page: string | number) => void
}

export interface IApplyFilter {
  prop: string
  type: OperatorTypeEnum
  values: string[]
  isReset?: boolean
  isModify?: boolean
}

/**
 * TODO : This OBGridFilter interface should be changed later
 */
export interface OBGridFilter {
  [key: string]: any
}

export interface ISelectableRows {
  setSelectedRows: (selectedRows: { [key: string]: boolean }) => void
  selectedRows: { [key: string]: boolean }
}
